import ChartJs from "chart.js";
import moment from "moment";

export default class GraphController {
    /**
     * @param {jQuery} $element
     * @param {string} type
     * @param {GraphDataProvider} dataProvider
     */
    constructor($element, type, dataProvider) {
        this.$element = $element;
        this.type = type;
        this.dataProvider = dataProvider;

        this.canvas = this.$element.find(".js-chart-canvas")[0];

        this.chart = new ChartJs(this.canvas, this.getChartSettings());

        this.bindEvents();
    }

    bindEvents() {
        const me = this;
        this.$element.on("click", ".js-change-date", function () {
            if (!me.date) {
                return false;
            }

            let $this = $(this);
            let direction = $this.attr("data-direction");

            let date = moment(me.date);

            date.add(direction === "forwards" ? 1 : -1, "year");
            me.setDate(date.toDate());
            return false;
        });
    }

    getChartSettings() {
        let xAxis = {
            stacked: true,
            gridLines: {
                display: false,
                drawBorder: false,
            },
        };

        let yAxis = {
            stacked: true,
            gridLines: {
                zeroLineWidth: 0,
                drawBorder: false,
                tickMarkLength: 0,
            },
            ticks: {
                suggestedMax: 100,
                padding: 10,
                stepSize: 20,
            },
        };

        return {
            type: this.type === "tablet" ? "bar" : "horizontalBar",
            data: {
                labels: [
                    '06:00',
                    '08:00',
                    '10:00',
                    '12:00',
                    '14:00',
                    '16:00',
                    '18:00',
                    '20:00',
                    '22:00',
                    '00:00',
                    '02:00',
                    '04:00',
                ],
                datasets: [],
            },
            options: {
                title: {
                    display: false,
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [
                        this.type === "tablet" ? xAxis : yAxis,
                    ],
                    yAxes: [
                        this.type === "tablet" ? yAxis : xAxis,
                    ],
                },
                legend: {
                    display: false,
                },
            },
        };
    }

    getCurrentData() {
        if (!this.date) {
            return [];
        }

        return this.dataProvider.getData(this.date);
    }

    /**
     * @param {Date} date
     */
    setDate(date) {
        this.date = date;

        this.$element.find(".js-current-date").text(moment(date).format("DD/MM/YYYY"));
        this.updateData();
    }

    updateData() {
        if (this.chart.data.datasets.length === 0) {
            this.chart.data.datasets = this.getCurrentData();
        } else {
            let currentData = this.getCurrentData();

            // Go through and update each dataset
            for (let i = 0; i < this.chart.data.datasets.length; i++) {
                this.chart.data.datasets[i].data = currentData[i].data;
            }
        }
        this.chart.update();
    }
}


ChartJs.defaults.global.defaultFontFamily = 'open-sans-web, Arial, Helvetica, sans-serif';
ChartJs.defaults.global.defaultFontSize = 12;
